import { actionScalePxPerFtUpdated, SCALE_ZOOM_THRESHOLD } from ".";

export const scaleGridEventHandler = (map, dispatch) => () => {
  if (!map) {
    return;
  }
  const zoom = map.getZoom();
  if (zoom < SCALE_ZOOM_THRESHOLD) {
    return;
  }

  // Calculate the scale in feet per pixel
  // using spherical law of cosines approximation
  // extrapolated from Mapbox GL JS scale control
  // https://github.com/mapbox/mapbox-gl-js/blob/b32d2ce6f9c59e679464a5ab3719cd1dad7f85a2/src/ui/control/scale_control.js

  const midHeight = map._container.clientHeight / 2;
  const latlng1 = map.unproject([0, midHeight]);
  const latlng2 = map.unproject([map._container.clientWidth, midHeight]);
  const R = 6371000;

  const rad = Math.PI / 180,
    lat1 = latlng1.lat * rad,
    lat2 = latlng2.lat * rad,
    a =
      Math.sin(lat1) * Math.sin(lat2) +
      Math.cos(lat1) *
        Math.cos(lat2) *
        Math.cos((latlng2.lng - latlng1.lng) * rad);

  const maxMeters = R * Math.acos(Math.min(a, 1));
  const maxFeet = 3.2808 * maxMeters;
  const pxPerFt = map._container.clientWidth / maxFeet;
  dispatch(actionScalePxPerFtUpdated({ pxPerFt }));
};
